import { ExternalLog } from "../externalLogging/ExternalLog";
import { PageIntegrationErrorFactory } from "../externalLogging/factories/PageIntegrationErrorFactory";

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("BasicLoader");

/**
 * Validate from where the game is being called from.
 * Since the game depends on an integration page, only runs the game when it is loaded from inside one iframe.
 * If the game is being called directly, only runs it if is running on a localhost environment, used for development or debug purpose.
 * Trying to access game directly from where it is deployed will show only the loading screen.
 */
const validateEnvironment = (): boolean => {
    return (window.parent !== window.self) ||
        (window.location.hostname.indexOf("localhost") >= 0) ||
        (window.document.location.hostname.indexOf("localhost") >= 0) ||
        (window.location.port === "8080") ||
        (window.location.port === "8081");
};

/**
 * Start to load CacheBreaker using the information attached to the index.html.
 * Since the link element is mandatory, check if the index.html page is providing it.
 * In case of not having found the link element, the game will fail silently.
 */
export const loadCacheBreaker = (): void => {
    if (!validateEnvironment()) {
        logger.error("Trying to run game without usage of an valid integration page.");
        return;
    }

    const script: HTMLScriptElement = document.createElement("script");
    const cacheBreakerLink: HTMLElement = document.getElementById("CacheBreaker");

    if (cacheBreakerLink) {
        script.src = cacheBreakerLink.getAttribute("href");
        document.body.appendChild(script);
    } else {
        logger.error("Unable to find the HTML link element with id 'CacheBreaker'.");
        ExternalLog.logger.log(new PageIntegrationErrorFactory(
            PageIntegrationErrorFactory.CACHE_BREAKER_ELEMENT_MISSING,
            "Unable to find the HTML link element with id 'CacheBreaker'."
        ));
    }
};
